module.exports = __webpack_public_path__ + "img/68.ecbf65f3.jpg";